import { iframeResizer } from 'iframe-resizer';

import { IframeHTMLAttributes, useEffect, useRef } from 'react';

type Props = IframeHTMLAttributes<HTMLIFrameElement>;

export function AutoHeightIFrame({ style, ...rest }: Props) {
  const ref = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    iframeResizer({ autoResize: true }, ref.current);
  }, []);

  return <iframe ref={ref} style={{ width: '1px', minWidth: '100%', ...style }} {...rest} />;
}
